import { FC, useMemo } from 'react';
import { Loader } from '@new/common/ui/Loader/Loader';
import { CourseList } from '@new/common/components/Course/CourseList';
import { useGetCoursesQuery } from '@teachur/http-client';
import { AllCoursesHeader } from '../components/AllCoursesHeader/AllCoursesHeader';
import { useAbility } from '@new/casl';

export const CoursePage: FC = () => {
  const ability = useAbility();
  const { data, isLoading } = useGetCoursesQuery(
    { page: 1, pageSize: 1000 },
    { staleTime: Infinity }
  );

  const courses = useMemo(() => {
    const allCourses = data?.data ?? [];

    if (ability.can('access', 'AdminPanel')) {
      return allCourses;
    }

    return allCourses.filter((course) => course.visibility === 'public');
  }, [data, ability]);

  if (isLoading) return <Loader />;
  return (
    <div className="flex flex-col p-6 lg:p-8 pt-0! gap-8">
      <CourseList courses={courses} header={<AllCoursesHeader courses={courses} />} />
    </div>
  );
};
